import React, { Component } from 'react'

export default class Loader extends Component {
    render() {
        return (
            <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                <div className="dot" />
                <div className="dot" />
                <div className="dot" />
            </div>
        )
    }
}
